/**
 * Function that tracks a click on an outbound link in Analytics.
 * This function takes a valid URL string as an argument, and uses that URL string
 * as the event label.
 */
window.trackOutboundLink = function (company_action, pos) {
  ga("send", "event", "click_out", company_action, pos, {
    "transport": "beacon",
    "hitCallback": function () {
      console.log("event send");
    }
  });
  window.uetq = window.uetq || [];
  window.uetq.push("event", "send", {"event_category": "click_out", "event_label": company_action, "event_value": pos});
};

window.mattressUpdate = function (el) {
  $.pjax.reload({
    url: "?id=" + $(el).val(),
    container: "#mattress_comparison",
    push: false,
    replace: false
  });
};

$(".js-reviewlinkopen").on("click", evt => {
  // evt.preventDefault();
  // evt.stopPropagation();
  let target = evt.target;
  let nwurl = target.dataset.nwurl;
  window.trackOutboundLink(target.dataset.title, target.dataset.rank);

  window.open(nwurl, "_blank,resizable,scrollbars,status");
  window.location = target.dataset.slug;
});